import { SignIn } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$pathLocale/_guest/sign-in/$')({
  component: RouteComponent,
});

function RouteComponent() {
  return <SignIn />;
}
